import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { MSmClientOpportunityEntity } from './m-sm-client-opportunity.entity';
import { WholesalerEntity } from './wholesaler.entity';

/**
 * PD-17101 — a competitor on an opportunity: who else is quoting, their price
 * when known, and on a loss which one won (on a win, the others are who we
 * beat). Competitors are `wholesaler` rows, picked with the competitor picker
 * so a name is never added twice.
 *
 * SM1 exposure: none (a new table).
 */
@Index('opportunity_competitor__opportunity_competitor', ['fkOpportunityId', 'fkWholesalerId'], {
	unique: true,
})
@Index('opportunity_competitor__fk_wholesaler__id', ['fkWholesalerId'], {})
@Entity('opportunity_competitor')
export class OpportunityCompetitorEntity extends BaseEntity {
	@Column('int', { name: 'fk_m_sm_client_opportunity__id', unsigned: true })
	public fkOpportunityId!: number;

	@Column('int', { name: 'fk_wholesaler__id', unsigned: true })
	public fkWholesalerId!: number;

	/** The competitor's price for the whole bid, when known. */
	@Column('decimal', { name: 'theirPrice', precision: 15, scale: 2, nullable: true })
	public theirPrice!: string | null;

	/** On a lost opportunity, the competitor that won it. At most one per opportunity. */
	@Column('tinyint', { name: 'isWinner', width: 1, default: () => "'0'" })
	public isWinner!: number;

	@Column('varchar', { name: 'note', length: 500, nullable: true })
	public note!: string | null;

	/**
	 * PD-17327 — where the bid came from, in the rep's words ("Told by Dan
	 * Kowalski", "Bid sheet from Conti"), and when it arrived.
	 */
	@Column('varchar', { name: 'bidSource', length: 255, nullable: true })
	public bidSource!: string | null;

	@Column('date', { name: 'bidReceivedDate', nullable: true })
	public bidReceivedDate!: string | null;

	/** PD-17327 — the bid document, one of the opportunity's files (type Competitor bid). */
	@Column('int', { name: 'fk__file__id_bid', unsigned: true, nullable: true })
	public fkFileIdBid!: number | null;

	@ManyToOne(() => MSmClientOpportunityEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_m_sm_client_opportunity__id', referencedColumnName: 'id' }])
	public opportunity!: MSmClientOpportunityEntity;

	@ManyToOne(() => WholesalerEntity, { onDelete: 'RESTRICT', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_wholesaler__id', referencedColumnName: 'id' }])
	public competitor!: WholesalerEntity;
}
